const cx = (...a) => a.filter(Boolean).join(' ');

export function Button({ variant = 'ghost', size, className, ...p }) {
  return <button {...p} className={cx('btn', `btn-${variant}`, size === 'sm' && 'btn-sm', className)} />;
}

export function Card({ title, action, className, children }) {
  return (
    <section className={cx('card', className)}>
      {(title || action) && (
        <header className="card-head">
          {title && <h2>{title}</h2>}
          {action}
        </header>
      )}
      {children}
    </section>
  );
}

export function Field({ label, required, children, hint }) {
  return (
    <label className="field">
      <span className="field-label">
        {label} {required && <b className="req">*</b>}
      </span>
      {children}
      {hint && <small className="hint">{hint}</small>}
    </label>
  );
}

export function Badge({ tone = 'neutral', children }) {
  return <span className={cx('badge', `badge-${tone}`)}>{children}</span>;
}

export function Spinner({ label = 'جارِ التحميل...' }) {
  return (
    <div className="center">
      <span className="spin" />
      <p className="muted">{label}</p>
    </div>
  );
}

export function Empty({ children = 'لا توجد بيانات' }) {
  return <div className="empty">{children}</div>;
}

export function Toast({ toast, onClose }) {
  if (!toast) return null;
  return (
    <div className={cx('toast', toast.ok ? 'toast-ok' : 'toast-bad')}>
      <span>{toast.msg}</span>
      <button onClick={onClose}>✕</button>
    </div>
  );
}